import { pgTable, serial, text, integer, timestamp, jsonb } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod/v4";

export const proposalDraftsTable = pgTable("proposal_drafts", {
  id: serial("id").primaryKey(),
  tenderId: integer("tender_id").notNull().unique(),
  language: text("language", { enum: ["ar", "en"] }).notNull().default("ar"),
  content: text("content"),
  introduction: text("introduction"),
  scopeUnderstanding: text("scope_understanding"),
  methodology: text("methodology"),
  team: text("team"),
  timeline: text("timeline"),
  qualityManagement: text("quality_management"),
  riskManagement: text("risk_management"),
  conclusion: text("conclusion"),
  // Structured pricing items: PricingDocument shape from
  // artifacts/api-server/src/lib/pricing.ts. When present, this is the
  // source of truth for export and totals — the markdown `pricing_table`
  // column is kept as a human-readable rendering for back-compat.
  pricingItems: jsonb("pricing_items"),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow(),
});

export const proposalVersionsTable = pgTable("proposal_versions", {
  id: serial("id").primaryKey(),
  tenderId: integer("tender_id").notNull(),
  versionNumber: integer("version_number").notNull(),
  label: text("label"),
  aiNotes: text("ai_notes"),
  type: text("type").notNull().default("ai_generated"),
  language: text("language").notNull().default("ar"),
  introduction: text("introduction"),
  scopeUnderstanding: text("scope_understanding"),
  methodology: text("methodology"),
  team: text("team"),
  timeline: text("timeline"),
  qualityManagement: text("quality_management"),
  riskManagement: text("risk_management"),
  conclusion: text("conclusion"),
  financialSummary: text("financial_summary"),
  pricingTable: text("pricing_table"),
  paymentTerms: text("payment_terms"),
  financialGuarantees: text("financial_guarantees"),
  totalAmount: text("total_amount"),
  filePath: text("file_path"),
  fileName: text("file_name"),
  fileType: text("file_type"),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  createdBy: text("created_by"),
});

export const insertProposalDraftSchema = createInsertSchema(proposalDraftsTable).omit({ id: true, createdAt: true, updatedAt: true });
export type InsertProposalDraft = z.infer<typeof insertProposalDraftSchema>;
export type ProposalDraft = typeof proposalDraftsTable.$inferSelect;
export type ProposalVersion = typeof proposalVersionsTable.$inferSelect;
